import { ExternalIntegrationsClient, ExternalIntegrationWithMetrics } from 'api/clients/ExternalIntegrationsClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useQuery, UseQueryOptions } from 'react-query'

interface Data {
  external_integrations: ExternalIntegrationWithMetrics[]
}

export const useExternalIntegrationsWithMetrics = (options?: UseQueryOptions<Data>) => {
  const workspaceId = useCurrentWorkspaceId()
  return useQuery<Data>(
    ['externalIntegrations', workspaceId, 'metrics'],
    async () => {
      const response = await ExternalIntegrationsClient.getExternalIntegrationsWithMetrics({ workspaceId })

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(response.data)
      }

      return response.data
    },
    {
      enabled: !!workspaceId,
      retry: false,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      cacheTime: 1000 * 60 * 5,
      ...options,
    },
  )
}
